import * as React from 'react';
import { ICardChecklistCopySectionProps } from './types';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { CardChecklistCopyHOC } from '../../hocs/CardChecklistCopyHOC/CardChecklistCopyHOC';
import { TChecklistId } from '../../../../../../../types/types';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardChecklistCopySection`) : null;

export function CardChecklistCopySection({
    isMultipleCards,
    selectedCardId,
    onCancel,
    onClose,
    setSelectedCardId
}: ICardChecklistCopySectionProps) {
    if (analyzeRender) analyzeRender.call(selectedCardId);
    const { boardId, cardId } = React.useContext(AsidePanelContext);

    const [selectedChecklistId, setSelectedChecklistId] = React.useState(null);

    return (
        <CardChecklistCopyHOC
            boardId={boardId}
            cardId={cardId}
            isMultipleCards={isMultipleCards}
            selectedCardId={selectedCardId}
            selectedChecklistId={selectedChecklistId}
            onSelectCard={setSelectedCardId}
            onSelectChecklists={setSelectedChecklistId}
            onCancel={onCancel}
            onClose={onClose}
        />
    );
};
